import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
    page: {
        fontFamily: 'Open Sans',
        fontSize: 10,
        padding: 20,
        lineHeight: 1.5
    },
    heading: {
        fontSize: 12,
        marginTop: 20,
        marginBottom: 10,
        textDecoration: 'underline'
    },
    link: {
        fontSize: 12,
        textAlign: 'center',
    },
    section: {
        padding: 10,
        backgroundColor: 'rgb(250,250,250)',
    },
    tableHeader: {
        flexDirection: 'row',
        borderBottom: '1 solid black',
        borderTop: '1 solid #ccc',
        borderRight: '1 solid #ccc',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: '1 solid #ccc',
        borderRight: '1 solid #ccc',
    },
    data: {
        flexDirection: 'row',
        paddingVertical: 2,
    },
    columnTitle: {
        flex: 3,
        padding: 4,
        borderLeft: '1 solid #ccc',
    },
    columnTitle2: {
        flex: 2,
        padding: 4,
        borderLeft: '1 solid #ccc',
    },
    columnRight: {
        flex: 1,
        padding: 4,
        borderLeft: '1 solid #ccc',
        textAlign: 'right',
    },
    columnLeft: {
        flex: 1,
        padding: 4,
        borderLeft: '1 solid #ccc',
        textAlign: 'left',
    },
    totalContainer: {
        paddingHorizontal: 20,
        paddingVertical: 10,
        backgroundColor: '#eee'
    },
    total: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
});